import React from 'react';
import DOMPurify from 'dompurify';
import { Box } from '@chakra-ui/react';
import { ChakraProps } from '@chakra-ui/react';

type SafeHTMLProps = {
  html: string;
  as?: React.ElementType;
  className?: string;
} & ChakraProps;

const customPurify = DOMPurify();

const allowedIframeHosts = [
  /^https:\/\/www\.youtube\.com\/embed\//,
  /^https:\/\/www\.loom\.com\/embed\//,
];

customPurify.addHook('uponSanitizeAttribute', (node, hookEvent) => {
  if (node.nodeName === 'IFRAME' && hookEvent.attrName === 'src') {
    const src = hookEvent.attrValue;
    const isAllowed = allowedIframeHosts.some((regex) => regex.test(src));

    if (!isAllowed) {
      hookEvent.attrValue = '';
    }
  }
});

export const SafeHTML: React.FC<SafeHTMLProps> = ({ html, as: Component = Box, ...props }) => {
  const sanitized = customPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target'],
    ADD_TAGS: ['iframe'],
  });

  return <Component {...props} dangerouslySetInnerHTML={{ __html: sanitized }} />;
};
